    /**
     * @ngdoc control
     * @name EmailSaveErrorToast
     * 
     * @description
     * Controller which is used for showing the toast when the automated email save process encounters an error
     *
     * @param {string} toastText - Text to be shown on the toast
     * @param {string/object} errorResponse - The error response which will be used to populate the dialog showing more information about the error.
     *                                        This can be a string or exception response.
     */

(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailSaveErrorToast', EmailSaveErrorToast);

    EmailSaveErrorToast.$inject = ['$scope', '$mdToast', 'DialogService', 'toastText', 'errorResponse'];

    function EmailSaveErrorToast($scope, $mdToast, DialogService, toastText, errorResponse) {
        $scope.toastText = toastText;
        $scope.close = close;
        $scope.showErrorInformation = showErrorInformation;

        /*
         * Show the error information. It will handle errorResponse being a string or a typical exception object
         */
        function showErrorInformation() {
            var messageToShow = '';

            if (_.isString(errorResponse)) {
                messageToShow = errorResponse;
            } else if (_.isObject(errorResponse) && !_.isNil(errorResponse.Message)) {
                messageToShow = errorResponse.Message;



            } else if (_.isObject(errorResponse) && !_.isNil(errorResponse.data) && !_.isNil(errorResponse.data.Message)) {
                messageToShow = errorResponse.data.Message;
            }

            DialogService.alert(messageToShow);
        }

        function close() {
            $mdToast.hide();
        }
    }
})();
